module.exports = __webpack_public_path__ + "static/dj_circle-ff795497ce74158e39ec5792ec62c3a9.png";